import React from 'react';

import type { RouteMatch } from '@confluence/route/entry-points/Route.ts';
import { LazyNBMPerformanceReportPage } from '@confluence/nbm-performance-report/entry-points/LazyNBMPerformanceReportPage.ts';
import { ADMIN_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs.ts';

export const AdminNBMPerformanceReportRoute: {
	({ params: { scanId } }: RouteMatch): React.JSX.Element;
	NAVIGATION_PARAMS(): {
		Screen: {
			screenEvent: {
				name: string;
			};
		};
		MainLayout: {
			navView: string;
		};
	};
} = ({ params: { scanId } }: RouteMatch): React.JSX.Element => (
	<LazyNBMPerformanceReportPage scanId={scanId} />
);

AdminNBMPerformanceReportRoute.NAVIGATION_PARAMS = (): {
	Screen: {
		screenEvent: {
			name: string;
		};
	};
	MainLayout: {
		navView: string;
	};
} => ({
	Screen: {
		screenEvent: { name: 'adminNBMPerformanceReport' },
	},
	MainLayout: {
		navView: ADMIN_HOME_ID,
	},
});
